import { Pipe, PipeTransform } from '@angular/core';
import { GuestRate, GuestRateKeys, MonthYearSelection } from 'ag-common-lib/public-api';

@Pipe({ name: 'maxGuestStartAgeForRate' })
export class MaxGuestStartAgeForRatePipe implements PipeTransform {
  transform(guestRate: GuestRate): number | undefined {
    return guestRate?.[GuestRateKeys.monthYearSelection] === MonthYearSelection.month ? 12 : undefined;
  }
}
